import React, { useEffect, useRef } from "react";
import Container from "../../styleguide/Container/Container";
import _get from "lodash/get";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../../../../../models";
import { Flash } from "../../../../../../models/state";
import { clearFlash } from "../../../../app/state/generalActions";
import { getFlash } from "../../../../app/state/selectors";
import Alert from "../../molecules/Alert/Alert";

const SCROLL_MARGIN = 150;
const STICKY_CART_HEIGHT = 100;
const SCROLL_ELEMENT_CLASS = "shopping-cart__accordion";

interface StateProps {
    flash?: Flash;
}

type ConnectedAlertProps = StateProps;

const ConnectedAlert: React.FC<ConnectedAlertProps> = ({ flash }) => {
    const alertRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (flash && flash.message) {
            let offset = SCROLL_MARGIN;
            const alertOffset = _get(alertRef, "current.offsetTop", 0);
            const stickyCart = _get(document.getElementsByClassName(SCROLL_ELEMENT_CLASS), "[0]", null);
            const isShowingStickyCart = !!_get(stickyCart, "offsetParent");

            // Need to take into consideration the sticky cart when doing scrollTo
            if (isShowingStickyCart) {
                offset = SCROLL_MARGIN + _get(stickyCart, "clientHeight", STICKY_CART_HEIGHT);
            }

            window.scrollTo({
                top: alertOffset - offset,
                // behavior: 'smooth'
                /* Smooth scrolling does not work with Firefox.
                 * It seems to be some render delay/problem when using 'smooth',
                 * causing scrolling to non correct offset */
            });
        }
    });

    if (flash && flash.message) {
        // Persistent flashes aren't auto-cleared on the next ajax call, so let the customer dismiss them manually.
        const onClose = flash.persistent
            ? () => {
                  dispatch(clearFlash(true));
              }
            : undefined;

        return (
            <Container size="small">
                <div ref={alertRef}>
                    <Alert kind={flash.type} onClose={onClose}>
                        <div dangerouslySetInnerHTML={{ __html: flash.message }} />
                    </Alert>
                </div>
            </Container>
        );
    }

    return null;
};
const mapStateToProps: (state: RootState) => StateProps = (state) => ({
    flash: getFlash(state),
});

export default connect(mapStateToProps)(ConnectedAlert);
